import { render } from "./MeasurePage.vue?vue&type=template&id=2535da3f"
import script from "./MeasurePage.vue?vue&type=script&lang=js"
export * from "./MeasurePage.vue?vue&type=script&lang=js"

import "./MeasurePage.vue?vue&type=style&index=0&id=2535da3f&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__